module.exports = "<!-- wrapper  start -->\r\n<section class=\"\" [ngClass]=\"{'section-display': sectionStatus}\">\r\n  <div id=\"wrapper\">\r\n    <bft-navigation></bft-navigation>\r\n    <bft-settings></bft-settings>\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.html
// module id = ./src/app/components/dashboard/dashboard.component.html
// module chunks = main